import React from 'react';
import {
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  Theme,
} from '../../index';
import { RemoveCircleOutline } from '@material-ui/icons';
import { DroppableListItemProps } from './models/transferListProps.types';

const useStyles = makeStyles((theme: Theme) => ({
  listItem: {
    backgroundColor: theme.palette.background.paper,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: theme.palette.divider,
  },
  roleAddedText: {
    padding: theme.spacing(1, 0),
  },
}));

export const DroppableListItem = ({ item, removeItem, index, itemIcon }: DroppableListItemProps): JSX.Element => {
  const classes = useStyles();

  return (
    <ListItem className={classes.listItem} data-testid={'DroppableListItem-component'}>
      {itemIcon && <ListItemAvatar style={{ position: 'relative', top: 2, minWidth: 0 }}>{itemIcon}</ListItemAvatar>}
      <ListItemText primary={item} data-testid={'added-role-list-item'} className={classes.roleAddedText} />
      <ListItemSecondaryAction>
        <IconButton edge="end" aria-label="delete" data-testid={'delete-role-button'} onClick={() => removeItem(index)}>
          <RemoveCircleOutline />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};
